export default __webpack_public_path__ + "static/media/icon-map-marker.6f0152e5.svg";